export default __webpack_public_path__ + "static/media/M23.cd00ca10.jpg";